import AuthorizeService from '@/v2/services/authorize';

export class ProductsModulePolicy {
	static async canCreateProduct(linkedMarketplaceId) {
		const PERMISSION = 'products.{linked_marketplace_id}.create';
		const neededPermissions = Array.isArray(linkedMarketplaceId)
			? linkedMarketplaceId.map(id => [
				PERMISSION,
				{ linked_marketplace_id: id }
			])
			: [PERMISSION, { linked_marketplace_id: linkedMarketplaceId }];
		return AuthorizeService.canAny(neededPermissions);
	}

	static canShowDetailedReport(linkedMarketplaceId) {
		const PERMISSION = 'products.{linked_marketplace_id}.detailed_report';
		const neededPermissions = Array.isArray(linkedMarketplaceId)
			? linkedMarketplaceId.map(id => [
				PERMISSION,
				{ linked_marketplace_id: id }
			])
			: [PERMISSION, { linked_marketplace_id: linkedMarketplaceId }];
		return AuthorizeService.canAll(neededPermissions);
	}

	static canUpdateMarketplaceProductPrices(linkedMarketplaceId) {
		const PERMISSION = 'products.{linked_marketplace_id}.pricing';
		if (Array.isArray(linkedMarketplaceId)) {
			return AuthorizeService.canAll(linkedMarketplaceId.map(id => [PERMISSION, { linked_marketplace_id: id }]));
		}
		return AuthorizeService.can(PERMISSION, {
			linked_marketplace_id: linkedMarketplaceId
		});
	}

	static canUpdateProductInventory(linkedMarketplaceId) {
		const PERMISSION = 'products.{linked_marketplace_id}.stock';
		if (Array.isArray(linkedMarketplaceId)) {
			return AuthorizeService.canAll(linkedMarketplaceId.map(id => [PERMISSION, { linked_marketplace_id: id }]));
		}
		return AuthorizeService.can(PERMISSION, {
			linked_marketplace_id: linkedMarketplaceId,
		});
	}

	static canUpdateProduct(linkedMarketplaceId) {
		const PERMISSION = 'products.{linked_marketplace_id}.update';
		if (Array.isArray(linkedMarketplaceId)) {
			return AuthorizeService.canAll(linkedMarketplaceId.map(id => [PERMISSION, { linked_marketplace_id: id }]));
		}
		return AuthorizeService.can(PERMISSION, {
			linked_marketplace_id: linkedMarketplaceId
		});
	}

	static canDeleteProduct(linkedMarketplaceId) {
		const PERMISSION = 'products.{linked_marketplace_id}.delete';
		if (Array.isArray(linkedMarketplaceId)) {
			return AuthorizeService.canAll(linkedMarketplaceId.map(id => [PERMISSION, { linked_marketplace_id: id }]));
		}
		return AuthorizeService.can(PERMISSION, {
			linked_marketplace_id: linkedMarketplaceId
		});	
	}
	
	static canUpdateProductStatus(linkedMarketplaceId) {
		const PERMISSION = 'products.{linked_marketplace_id}.status_update';
		if (Array.isArray(linkedMarketplaceId)) {
			return AuthorizeService.canAll(linkedMarketplaceId.map(id => [PERMISSION, { linked_marketplace_id: id }]));
		}
		return AuthorizeService.can(PERMISSION, {
			linked_marketplace_id: linkedMarketplaceId
		});	
	}
}
